var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2598 12C18.4121 12 16.0827 14.3866 16.0827 17.3021C16.0827 19.0849 16.9562 20.6635 18.2842 21.624C15.1929 22.8928 13.0003 25.9882 13.0003 29.5991C12.9756 30.7375 14.6562 30.7375 14.6315 29.5991C14.6315 25.7663 17.65 22.6776 21.3937 22.6776C22.7005 22.6776 23.9135 23.0589 24.946 23.7131C25.8742 24.2959 26.728 22.8706 25.7998 22.2878C25.335 21.9933 24.8312 21.7637 24.312 21.5652C25.5939 20.5999 26.4322 19.0494 26.4322 17.3021C26.4322 14.3866 24.1076 12 21.2598 12ZM21.2598 13.6717C23.226 13.6717 24.801 15.2892 24.801 17.3021C24.801 19.3151 23.226 20.9259 21.2598 20.9259C19.2937 20.9259 17.7139 19.3151 17.7139 17.3021C17.7139 15.2892 19.2937 13.6717 21.2598 13.6717ZM26.2634 27.8801V29.5502C26.287 30.6391 27.871 30.6391 27.8946 29.5502V27.8801H29.5274C30.6159 27.8801 30.6159 26.2085 29.5274 26.2085H27.8946V24.5384C27.8999 24.0703 27.5283 23.689 27.071 23.6936C26.6199 23.6967 26.2581 24.0766 26.2634 24.5384V26.2085H24.5931C23.4656 26.2618 23.5436 27.9334 24.6322 27.8801H26.2634Z",
    fill: "#033476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.1b9aef5f1766a3fa7a7ca6833d3b8af2.svg";
export { ForwardRef as ReactComponent };